$(document).ready(function() {
    var header = document.getElementsByClassName('site-header')[0]
    var lang = document.getElementsByClassName('site-header-nav-lang--dropdown')[0]
    var support = document.getElementsByClassName('site-header-nav-sub-wrapper')[0]

    var toggle = document.getElementById('toggle')
    var rezeptClose = document.getElementById('rezept-close')
    var langToggle = document.getElementById('lang-toggle')
    var supportToggle = document.getElementsByClassName('site-header-nav-sub-toggle')[0]

    if (supportToggle) {
        supportToggle.addEventListener('click', function () {
            support.classList.toggle('toggled')
        })

        window.addEventListener('click', function (e) {
            if (!supportToggle.contains(e.target)) {
                support.classList.remove('toggled')
            }
        })
    }

    if (toggle) {
        toggle.addEventListener('click', function () {
            header.classList.toggle('toggled')
        })

        const links = document.querySelectorAll('.site-header-nav-main a[href^="#anchor-"]');

        links.forEach(function(link) {
            link.addEventListener('click', function(event) {
                header.classList.remove('toggled');
            });
        });
    }

    //close mobile navbar by Rezept beantragen btns
    if (rezeptClose) {
        rezeptClose.addEventListener('click', function () {
            header.classList.toggle('toggled')
        })
    }

    if (langToggle) {
        langToggle.addEventListener('click', function () {
            lang.classList.toggle('toggled')
        })

        window.addEventListener('click', function (e) {
            if (!document.getElementById('lang-toggle').contains(e.target)) {
                lang.classList.remove('toggled')
            }
        })
    }
})
